<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span>Move or Copy (Drag and Drop)</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div
                id="filterDay"
                class="btn-group"
                data-toggle="buttons"
              >
                <label class="btn btn-default blue">
                  <input
                    class="toggle"
                    type="radio"
                    value="1"
                    @click="move(1)"
                  />
                  move with children
                </label>
                <label class="btn btn-default blue">
                  <input
                    class="toggle"
                    type="radio"
                    value="2"
                    @click="move(2)"
                  />
                  move alone
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDragAndDrop',
  methods: {
    move(option) {
      this.$emit('move', { id: option })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &-header {
    span {
      font-weight: bold;
    }
  }

  &-body {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalDragAndDrop.vue